export interface ArticleContent {
  id: string;
  title: string;
  description: string;
  content: string;
  coverImage: string;
  category: string;
  author: string;
  publishDate: string;
  tags: string[];
  slug: string;
  views: number;
  relatedVideos: string[];
}

export const articles: ArticleContent[] = [
  {
    id: 'a001',
    title: '2024年度最受欢迎华语电影合集',
    description: '精心挑选的年度最佳华语电影，涵盖动作、爱情、喜剧等多种类型，每一部都是口碑佳作，让您一次看过瘾。',
    content: `<h2>年度最佳华语电影回顾</h2>
    <p>2024年是华语电影蓬勃发展的一年，众多优秀作品在大银幕上绽放光彩。我们精心挑选了以下年度最佳华语电影，为影迷朋友们带来一场视觉盛宴。</p>
    <h3>动作大片：热血燃爆</h3>
    <p>本年度动作电影无论是场面调度还是特效制作都达到了新的高度。多部作品在国内外取得了优异的票房成绩，展现了中国电影工业的强大实力。</p>
    <p>其中不乏融合了中国传统文化元素与现代表现手法的佳作，让观众在享受视觉冲击的同时，也能感受到深厚的文化底蕴。</p>
    <h3>爱情佳作：温暖人心</h3>
    <p>爱情题材在2024年同样表现亮眼，多部作品以细腻的情感表达和深刻的人文关怀赢得了观众的喜爱。这些电影不仅仅讲述爱情故事，更折射出当代社会的情感百态。</p>
    <h3>喜剧力作：笑声不断</h3>
    <p>喜剧电影一直是华语电影的重要组成部分。今年的喜剧作品在笑点设计上更加精巧，叙事结构也更加成熟，让观众在欢笑声中收获思考与感动。</p>
    <p>无论你喜欢哪种类型，这份合集都能满足你的观影需求。快来开启你的电影之旅吧！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20cinematic%20movie%20poster%20composition%20with%20warm%20golden%20lighting%2C%20abstract%20film%20reel%20texture%2C%20elegant%20Chinese%20calligraphy%20style%2C%20soft%20gradient%20background%20in%20warm%20amber%20tones%2C%20professional%20movie%20poster%20design%20aesthetic&width=800&height=450&seq=article-cover-001&orientation=landscape',
    category: 'dianshiju',
    author: '福利视频在线编辑部',
    publishDate: '2024-12-15',
    tags: ['电影', '华语', '热门', '高分'],
    slug: '2024-best-chinese-movies',
    views: 1520000,
    relatedVideos: ['v003', 'v009'],
  },
  {
    id: 'a002',
    title: '爆笑综艺合集：让你笑到停不下来',
    description: '汇集全网最搞笑的综艺片段，涵盖脱口秀、真人秀、游戏竞技等多种类型，陪伴你度过欢乐时光。',
    content: `<h2>综艺节目的无限魅力</h2>
    <p>综艺节目已经成为现代人休闲娱乐的重要方式。从竞技类到真人秀，从音乐选秀到脱口秀，各种形式的综艺节目为观众带来了无尽欢乐。</p>
    <h3>脱口秀：幽默与智慧并存</h3>
    <p>脱口秀节目以其独特的幽默表达和犀利的社会观察赢得了大量观众。优秀的脱口秀演员能够将生活中的点滴转化为令人捧腹的段子，同时引发观众的共鸣与思考。</p>
    <h3>真人秀：真实与戏剧交织</h3>
    <p>真人秀节目通过记录参与者的真实反应和互动，呈现出令人意想不到的戏剧效果。明星嘉宾在镜头前的自然表现让观众看到了他们最真实的一面。</p>
    <h3>游戏竞技：紧张与欢乐并存</h3>
    <p>游戏竞技类综艺融合了运动、智力和团队协作的元素，参与者们在激烈竞争的同时，也不忘制造欢乐的氛围。</p>
    <p>本合集精心筛选了最受欢迎的综艺内容，让你一次笑个够！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20lighting%20effects%2C%20dynamic%20atmosphere%2C%20warm%20spotlight%2C%20entertainment%20studio%20background%20with%20abstract%20geometric%20patterns%2C%20joyful%20and%20energetic%20mood&width=800&height=450&seq=article-cover-002&orientation=landscape',
    category: 'zongyi',
    author: '福利视频在线编辑部',
    publishDate: '2025-01-08',
    tags: ['综艺', '搞笑', '娱乐', '热门'],
    slug: 'funny-variety-show-compilation',
    views: 2380000,
    relatedVideos: ['v001', 'v008'],
  },
  {
    id: 'a003',
    title: '精选创意短视频：每日新鲜看不停',
    description: '来自全网创作者的精彩短视频作品，包含生活妙招、美食制作、旅行记录、萌宠日常等丰富内容。',
    content: `<h2>短视频时代的创意盛宴</h2>
    <p>短视频已经成为当下最受欢迎的内容消费形式。在短短几分钟内，创作者们将创意、知识和情感浓缩呈现，让用户在碎片化时间中获得丰富的体验。</p>
    <h3>生活妙招：实用又有趣</h3>
    <p>从厨房小技巧到收纳整理，生活妙招类短视频让我们发现了日常生活中的无限创意。这些简单实用的方法不仅节省时间，还能提升生活品质。</p>
    <h3>美食制作：视觉与味蕾的双重享受</h3>
    <p>美食短视频通过精美的画面和详细的步骤展示，让观众仿佛能闻到食物的香气。无论是家常菜还是精致料理，都能在这里找到灵感。</p>
    <h3>萌宠日常：治愈系内容之王</h3>
    <p>可爱的小动物们总是能轻易俘获我们的心。萌宠短视频以其天然的治愈力成为平台上的流量担当。</p>
    <p>每天都有新鲜内容更新，保证让你看了还想看！</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20short%20video%20collage%20with%20warm%20earthy%20tones%2C%20smartphone%20screen%20displaying%20various%20content%20thumbnails%2C%20modern%20social%20media%20aesthetic%2C%20cozy%20ambient%20lighting%2C%20minimalist%20composition%20with%20soft%20shadows&width=800&height=450&seq=article-cover-003&orientation=landscape',
    category: 'duanshipin',
    author: '福利视频在线编辑部',
    publishDate: '2025-02-20',
    tags: ['短视频', '创意', '生活', '热门'],
    slug: 'creative-short-videos-daily',
    views: 3210000,
    relatedVideos: ['v005', 'v010'],
  },
  {
    id: 'a004',
    title: '经典动漫剧场版合集：回忆与感动',
    description: '精选经典动漫剧场版作品，从热血少年到治愈日常，每一部都是动漫迷不可错过的经典之作。',
    content: `<h2>动漫剧场版的独特魅力</h2>
    <p>动漫剧场版以其精良的制作、宏大的叙事和深刻的情感表达，成为动漫文化中最耀眼的明珠。相比TV动画，剧场版拥有更高的制作预算和更广阔的创作空间。</p>
    <h3>热血少年：永不熄灭的斗志</h3>
    <p>热血少年向的剧场版作品以其激昂的战斗场景和励志的成长故事深受观众喜爱。主角们在逆境中不断突破自我，传递着永不言弃的精神。</p>
    <h3>治愈日常：温暖人心的小确幸</h3>
    <p>治愈系剧场版以细腻的情感和精美的画面著称。这些作品往往以日常生活为背景，通过人物之间的温情互动，带给观众心灵的慰藉。</p>
    <h3>奇幻冒险：想象力无极限</h3>
    <p>奇幻冒险类剧场版将观众带入充满想象力的世界。宏大的世界观设定、精美的场景设计，让每一帧画面都值得珍藏。</p>
    <p>无论你是资深动漫迷还是刚入坑的新手，这份合集都能带你领略动漫世界的无限精彩。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20warm%20sunset%20sky%2C%20beautiful%20character%20silhouettes%2C%20dreamy%20atmosphere%2C%20soft%20golden%20clouds%2C%20emotional%20and%20nostalgic%20vibe%2C%20flat%20color%20design%20with%20gentle%20textures&width=800&height=450&seq=article-cover-004&orientation=landscape',
    category: 'dongman',
    author: '福利视频在线编辑部',
    publishDate: '2025-01-25',
    tags: ['动漫', '剧场版', '经典', '高分'],
    slug: 'classic-anime-movies-collection',
    views: 1870000,
    relatedVideos: ['v006', 'v011'],
  },
  {
    id: 'a005',
    title: '地球脉动：自然纪录片的震撼之美',
    description: '高清纪录片带你领略地球最美的自然风光，从极地冰川到热带雨林，感受大自然的神奇与壮丽。',
    content: `<h2>纪录片：用镜头记录地球之美</h2>
    <p>纪录片是了解世界的窗口。通过先进的拍摄技术和专业的制作团队，纪录片将地球上最壮观的自然景观和最动人的生命故事呈现在观众面前。</p>
    <h3>极地冰川：冰雪世界的奥秘</h3>
    <p>极地地区是地球上最神秘的地带之一。纪录片团队冒着严寒，记录下了冰川运动、极光绚烂以及极地动物的生存状态，让我们得以一窥这片净土的魅力。</p>
    <h3>热带雨林：生命多样性的宝库</h3>
    <p>热带雨林是地球上生物多样性最丰富的生态系统。高清镜头下的雨林世界充满了令人惊叹的色彩和形态，每一种生物都在演绎着独特的生存智慧。</p>
    <h3>海洋深处：蓝色星球的秘密</h3>
    <p>海洋覆盖了地球表面的70%以上，然而人类对深海的了解还非常有限。海洋纪录片为我们揭开了深海世界的神秘面纱。</p>
    <p>通过这些震撼的纪录片，让我们更加珍惜这个美丽的蓝色星球。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20landscape%20with%20warm%20golden%20hour%20sunlight%2C%20mountain%20range%20reflected%20in%20crystal%20lake%2C%20documentary%20cinematography%20style%2C%20rich%20earthy%20tones%20of%20forest%20green%20and%20amber%2C%20breathtaking%20scenic%20view&width=800&height=450&seq=article-cover-005&orientation=landscape',
    category: 'jilupian',
    author: '福利视频在线编辑部',
    publishDate: '2025-03-01',
    tags: ['纪录片', '自然', '高清', '震撼'],
    slug: 'planet-earth-nature-documentary',
    views: 980000,
    relatedVideos: ['v007', 'v012'],
  },
  {
    id: 'a006',
    title: 'NBA精彩赛事回放：巅峰对决时刻',
    description: '精选本赛季最精彩的NBA比赛回放，包含绝杀瞬间、巨星对决、经典逆转等令人热血沸腾的比赛。',
    content: `<h2>NBA赛场的激情与荣耀</h2>
    <p>NBA作为世界最高水平的篮球联赛，每一场比赛都充满了悬念与激情。从常规赛到季后赛，无数经典时刻被铭刻在篮球历史的丰碑上。</p>
    <h3>绝杀时刻：一秒定乾坤</h3>
    <p>终场哨响前的一刹那，当篮球划出完美弧线落入篮筐，全场沸腾。绝杀是篮球比赛中最令人心跳加速的时刻，也是体育精神最极致的体现。</p>
    <h3>巨星对决：巅峰之战</h3>
    <p>当联盟顶级球星在赛场上相遇，每一回合的攻防都精彩纷呈。他们的技术、智慧和意志力在比赛中得到充分展现。</p>
    <h3>历史经典：永恒的记忆</h3>
    <p>从乔丹的"最后一投"到科比的81分，NBA历史上留下了太多令人难忘的经典瞬间。这些比赛录像成为了篮球迷心中永恒的宝藏。</p>
    <p>福利视频在线为您精选本赛季最精彩的NBA比赛回放，重温那些激动人心的篮球盛宴。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Basketball%20arena%20with%20dramatic%20lighting%2C%20warm%20court%20spotlights%2C%20dynamic%20sports%20action%20moment%2C%20energetic%20stadium%20atmosphere%2C%20professional%20sports%20photography%20style%2C%20rich%20amber%20and%20orange%20accents&width=800&height=450&seq=article-cover-006&orientation=landscape',
    category: 'tiyu',
    author: '福利视频在线编辑部',
    publishDate: '2025-02-15',
    tags: ['NBA', '篮球', '赛事', '精彩'],
    slug: 'nba-highlights-replay',
    views: 2100000,
    relatedVideos: ['v002', 'v004'],
  },
];